@use "@fukuri-admins/ui/layout" as *;

.container {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
}

.pageTitle {
  @include typography('Jp/24_W6');
  color: text('High');
  margin: 0;
}

.infoBanner {
  display: flex;
  gap: spacing("12");
  padding: spacing("16");
  background: background('Sky');
  border-radius: borderRadius('md');
}

.infoIcon {
  color: text('Sky');
  flex-shrink: 0;
  margin-top: spacing("2");
}

.infoBannerContent {
  display: flex;
  flex-direction: column;
  gap: spacing("8");

  p {
    @include typography('Jp/14_W3');
    color: text('Low');
    margin: 0;
  }

  .link {
    @include typography('Jp/14_W3');
  }

}

.link {
  @include typography('Jp/12_W3');
  color: text('Link');
  text-decoration: none;

  &:hover {
    color: text('Hover');
  }
}

.businessLocationSelector {
  display: flex;
  flex-direction: column;
  gap: spacing("8");
}

.businessLocationLabel {
  @include typography('Jp/14_W3');
  color: text('High');
  display: flex;
  align-items: center;
  gap: spacing("4");
}

.tooltipWrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.tooltip {
  @include typography('Jp/12_W3');
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  max-width: 384px;
  width: max-content;
  pointer-events: none;
  color: text('White');
  background: background('Gray_Darken');
  padding: spacing("8") spacing("12");
  border-radius: borderRadius('sm');
  z-index: 10;
  transition: opacity 120ms ease, visibility 120ms ease;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -4px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 6px 6px 0;
    border-color: transparent background('Gray_Darken') transparent transparent;
  }
}

.tooltipWrapper:hover .tooltip {
  opacity: 1;
  visibility: visible;
}

.selectWrapper {
  width: 270px;
}

.businessLocationDropdown {
  @include typography('Jp/14_W3');
  color: text('High');
  background: background('Primary');
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('md');
  padding: spacing("12") spacing("16");
  max-width: 300px;
}

.contentWrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: spacing("32");

  @media screen and (max-width: $TB) {
    grid-template-columns: 1fr;
  }
}

.leftSection {
  display: flex;
  flex-direction: column;
}

.rightSection {
  display: flex;
  flex-direction: column;
  position: sticky;
  top: spacing("24");
  align-self: flex-start;
}

.stepNumber {
  @include typography('Jp/12_W3');
  color: text('White');
  background: background('Sky_Darken');
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stepTitle {
  @include typography('Jp/14_W6');
  color: text('High');
  margin: 0;
  display: flex;
  align-items: center;
  gap: spacing("4");
}

.stepDescription {
  @include typography('Jp/12_W3');
  color: text('Low');
  margin: 0;
}

.infoCard {
  background: background('Secondary');
  border-radius: borderRadius('md');
  padding: spacing("16");
  margin-top: spacing("8");
}

.infoCardTitle {
  @include typography('Jp/12_W6');
  color: text('Low');
  margin: 0 0 spacing("12") 0;
}

.infoCardRow {
  display: flex;
  gap: spacing("16");
  margin-bottom: spacing("8");

  &:last-child {
    margin-bottom: 0;
  }
}

.infoCardLabel {
  @include typography('Jp/12_W3');
  color: text('Low');
  min-width: 120px;
}

.infoCardValue {
  @include typography('Jp/12_W3');
  color: text('Low');
}

.templatePreview {
  background: background('Secondary');
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('md');
  padding: spacing("16");
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: auto;
}

.templateImage {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
